<template>
  <div>
    <DxTabPanel>
      <DxTabPanelItem title="Tabel" icon="rowfield">
        <div class="row">
          <!-- Tabel Tunggakan-->
          <div class="col-lg-12">
            <div class="dx-card px-3 py-4 mt-3">
              <div style="height: calc(100vh - 200px);">
                <DxDataGrid
                    :dataSource="dashboardStore.datasourceTunggakan"
                    @exporting="dashboardStore.onExportingExcel"
                    @editing-start="dashboardStore.onEditingStart"
                    @rowPrepared="dashboardStore.onRowPrepared"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :hover-state-enabled="true"
                    :show-column-lines="true"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="false"
                    :remote-operations="true"
                    style="height:100%"
                    :sorting="{mode: 'multiple'}"
                    :scrolling="{mode: 'virtual',rowRenderingMode: 'virtual',columnRenderingMode: 'virtual',useNative: true}"
                >
                  <DxToolbar>
                    <DxItem location="before">
                      <h5><span>Rekap Tunggakan</span></h5>
                    </DxItem>
                    <DxItem location="before">
                      <DxDateBox
                          v-model:value="mdrdStore.selectedFilterTempoSampaiDengan"
                          :show-clear-button="true"
                          label="Tempo S/D"
                          type="date"
                          value-change-event="keyup"
                          @value-changed="dashboardStore.onChangedSelectedFilterTempoSampaiDengan"
                          display-format="dd/MM/yyyy"
                      />
                    </DxItem>
                    <DxItem location="before">
                      <DxDateBox
                          v-model:value="mdrdStore.selectedFilterTanggalSegel"
                          :show-clear-button="true"
                          label="Tgl Segel"
                          type="date"
                          value-change-event="keyup"
                          @value-changed="dashboardStore.onChangedSelectedFilterTanggalSegel"
                          display-format="dd/MM/yyyy"
                      />
                    </DxItem>
                    <DxItem location="before">
                      <DxDateBox
                          v-model:v:alue="mdrdStore.selectedFilterTanggalCabut"
                          :show-clear-button="true"
                          label="Tgl Cabut"
                          type="date"
                          value-change-event="keyup"
                          @value-changed="dashboardStore.onChangedSelectedFilterTanggalCabut"
                          display-format="dd/MM/yyyy"
                      />
                    </DxItem>
                    <DxItem location="before">
                      <DxTextBox
                          v-model:value="mdrdStore.selectedFilterLainLain"
                          placeholder="Lain-lain"
                          :show-clear-button="true"
                          value-change-event="keyup"
                          @value-changed="dashboardStore.onChangedSelectedFilterLainLain"
                      />
                    </DxItem>
                    <DxItem location="before">
                      <DxSelectBox
                          v-model:value="mdrdStore.selectedFilterStatus"
                          placeholder="Status Tindakan"
                          :dataSource="dashboardStore.dataSourceStatus"
                          :displayExpr="'display'"
                          :valueExpr="'value'"
                          @value-changed="dashboardStore.onChangedSelectedFilterStatus"
                      />
                    </DxItem>
                    <DxItem location="after" name="columnChooserButton">
                    </DxItem>
                    <DxItem location="after" name="exportButton">
                    </DxItem>
                  </DxToolbar>
                  <DxExport :enabled="true"/>
                  <DxEditing
                      :allow-updating="true"
                      :allow-deleting="false"
                      :allow-adding="false"
                      mode="popup"
                  >
                    <DxPopup
                        :show-title="true"
                        :width="700"
                        :height="525"
                        title="Tindak Lanjut Tunggakan"
                    />
                    <DxForm>
                      <DxItem
                          :col-count="2"
                          :col-span="2"
                          item-type="group"
                      >
                        <DxItem data-field="tanggal_tempo"/>
                        <DxItem
                            data-field="tanggal_segel"
                            :editor-options="{ type: 'date', max: new Date() }"
                        />
                        <DxItem
                            data-field="tanggal_cabut"
                            :editor-options="{ type: 'date', max: new Date() }"
                        />
                        <DxItem data-field="lain_lain"/>
                      </DxItem>
                    </DxForm>
                  </DxEditing>
                  <DxPaging
                      :enabled="true"
                      :page-size="100"
                  />
                  <DxPager
                      :visible="true"
                      :showPageSizeSelector="false"
                      :showNavigationButtons="false"
                      :show-info="true"
                      :infoText="'Page {0} of {1} ({2} items)'"
                  />
                  <DxFilterRow :visible="true" apply-filter="auto"/>
                  <DxScrolling mode="virtual"/>
                  <DxSelection mode="single"/>
                  <DxHeaderFilter :visible="true"/>
                  <DxColumnChooser :enabled="true"/>
                  <DxColumn
                      caption="Sudah Di Tindak Lanjuti"
                      dataField="status"
                      width="auto"
                      :fixed=true
                      fixedPosition="left"
                      :allowEditing="false"
                      :allowHeaderFiltering="false"
                      :allowFiltering="false"
                  />
                  <DxColumn
                      dataField="nosbg"
                      caption="Nosbg"
                      width="auto"
                      :allowHeaderFiltering="false"
                      :fixed=true
                      fixedPosition="left"
                      :allowEditing="false"
                  />
                  <DxColumn caption="Tunggakan">
                    <DxColumn
                        dataField="nama"
                        caption="Nama"
                        :allowHeaderFiltering="false"
                    />
                    <DxColumn
                        dataField="alamat"
                        caption="Alamat"
                        :allowHeaderFiltering="false"
                    />
                    <DxColumn
                        dataField="gol"
                        caption="Gol"
                        :allowHeaderFiltering="true"
                        :header-filter="{dataSource: commonStore.golonganHeaderFilters}"
                    />
                    <DxColumn
                        dataField="rayon"
                        caption="Rayon"
                        :allowHeaderFiltering="true"
                        :header-filter="{dataSource: commonStore.rayonHeaderFilters}"
                    />
                    <DxColumn
                        dataField="kelompok"
                        caption="Kelompok"
                        :allowHeaderFiltering="true"
                        :header-filter="{dataSource: commonStore.kelompokHeaderFilters}"
                    />
                    <DxColumn
                        dataField="jml_tunggakan"
                        caption="Jml Tunggakan"
                        :allowHeaderFiltering="false"
                    />
                    <DxColumn
                        dataField="jml_bayar"
                        caption="Jml Bayar"
                        sortOrder="desc"
                        :allowHeaderFiltering="false"
                        :format="formaterStore.priceFormat"
                    />
                    <DxColumn
                        dataField="pemakaian"
                        caption="Pemakaian"
                        :allowHeaderFiltering="false"
                        :visible="false"
                    />
                    <DxColumn
                        dataField="oldest_rekening"
                        caption="Awal Rekening"
                        :allowHeaderFiltering="false"
                    />

                  </DxColumn>
                  <DxColumn caption="Tindak Lanjut">
                    <DxColumn
                        caption="Tempo s/d Tanggal"
                        dataField="tanggal_tempo"
                        dataType="date"
                        :width="120"
                        :allowFiltering="false"
                        :allowHeaderFiltering="false"
                        :format="formaterStore.dateYyyyMmDd"
                        :allowSorting="false"
                    />
                    <DxColumn
                        caption="Tgl Segel"
                        dataField="tanggal_segel"
                        :width="120"
                        :allowFiltering="false"
                        :allowHeaderFiltering="false"
                        data-type="date"
                        :format="formaterStore.dateYyyyMmDd"
                        :allowSorting="false"
                    />
                    <DxColumn
                        caption="Tgl Cabut"
                        dataField="tanggal_cabut"
                        :width="120"
                        :allowFiltering="false"
                        :allowHeaderFiltering="false"
                        data-type="date"
                        :format="formaterStore.dateYyyyMmDd"
                        :allowSorting="false"
                    />
                    <DxColumn
                        caption="Lain-lain"
                        dataField="lain_lain"
                        :width="120"
                        :allowFiltering="false"
                        :allowHeaderFiltering="false"
                        :allowSorting="false"
                    />

                  </DxColumn>

                  <!--                  <DxColumn
                                        caption="EDIT"
                                        type="buttons"
                                        :fixed="true"
                                        fixedPosition="right"
                                    >
                                      <template v-slot:cellTemplate="{ data }">
                                        <div v-if="dashboardStore.showEdit(data)">
                                          <DxButtonDatagrid name="edit" />
                                        </div>
                                      </template>
                                    </DxColumn>-->
                  <DxColumn
                      caption="EDIT"
                      type="buttons"
                      :fixed="true"
                      fixedPosition="right"
                  >
                    <DxButtonDatagrid
                        name="edit"
                    />
                  </DxColumn>
<!--                  <DxColumn
                      caption="EDIT"
                      type="buttons"
                      :fixed="true"
                      fixedPosition="right"
                      cell-template="editing-button-template"
                  >

                  </DxColumn>

                  <template #editing-button-template="{ data: templateOptions }">
                    <div v-if="dashboardStore.showEdit(templateOptions)">
                      <DxButtonDatagrid
                          name="edit"
                          :visible="true"
                      />
                    </div>
                  </template>-->

                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </DxTabPanelItem>
      <DxTabPanelItem title="Tugas Segel" icon="unlock">
        <div class="row">
          <!-- Tugas Segel -->
          <div class="col-lg-12">
            <div class="dx-card px-3 py-4 wide-card">
              <div style="height: calc(100vh - 300px); min-height: 640px">
                <DxDataGrid
                    :dataSource="dashboardStore.datasourceTugasSegel"
                    @exporting="dashboardStore.onExportingExcel"
                    @editing-start="dashboardStore.onEditingStart"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :hover-state-enabled="true"
                    :show-column-lines="true"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="true"
                    :remote-operations="true"
                    style="height:100%"
                    :sorting="{mode: 'multiple'}"
                    :scrolling="{mode: 'virtual',rowRenderingMode: 'virtual',columnRenderingMode: 'virtual',useNative: true}"
                >
                  <DxToolbar>
                    <DxItem location="before">
                      <h5><span>Daftar Tugas Segel</span></h5>
                    </DxItem>
                    <DxItem location="after" name="columnChooserButton">
                    </DxItem>
                    <DxItem location="after" name="exportButton">
                    </DxItem>
                  </DxToolbar>
                  <DxExport :enabled="true"/>
                  <!-- <DxEditing
                      :allow-updating="true"
                      :allow-deleting="false"
                      :allow-adding="false"
                      mode="popup"
                  >
                    <DxPopup
                        :show-title="true"
                        :width="700"
                        :height="525"
                        title="Tindak Lanjut Tunggakan"
                    />
                    <DxForm>
                      <DxItem
                          :col-count="2"
                          :col-span="2"
                          item-type="group"
                      >
                        <DxItem data-field="tanggal_tempo"/>
                        <DxItem
                            data-field="tanggal_segel"
                            :editor-options="{ type: 'date', max: new Date() }"
                        />
                        <DxItem
                            data-field="tanggal_cabut"
                            :editor-options="{ type: 'date', max: new Date() }"
                        />
                        <DxItem data-field="lain_lain"/>
                      </DxItem>
                    </DxForm>
                  </DxEditing> -->
                  <DxPaging
                      :enabled="true"
                      :page-size="100"
                  />
                  <DxPager
                      :visible="true"
                      :showPageSizeSelector="false"
                      :showNavigationButtons="false"
                      :show-info="true"
                      :infoText="'Page {0} of {1} ({2} items)'"
                  />
                  <DxFilterRow :visible="true" apply-filter="auto"/>
                  <DxScrolling mode="virtual"/>
                  <DxSelection mode="single"/>
                  <DxHeaderFilter :visible="true"/>
                  <DxColumnChooser :enabled="true"/>
                  
                  <DxColumn data-field="tagihan_connection_id" caption="Tagihan Connection ID" 
                  :allowHeaderFiltering="false"  :visible="false"/>
                  <DxColumn data-field="id" caption="ID" 
                  :allowHeaderFiltering="false" :visible="false"/>
                  <DxColumn data-field="nomor_sambungan" caption="Nomor Sambungan" 
                  :allowHeaderFiltering="false"/>
                  <DxColumn data-field="nama_pelanggan" caption="Nama Pelanggan" 
                  :allowHeaderFiltering="false"/>
                  <DxColumn data-field="alamat" caption="Alamat" 
                  :allowHeaderFiltering="false"/>
                  <DxColumn data-field="rayon" caption="Rayon" 
                  :header-filter="{dataSource: commonStore.rayonHeaderFilters}"/>
                  <DxColumn data-field="golongan" caption="Golongan" 
                  :header-filter="{dataSource: commonStore.golonganHeaderFilters}"/>
                  <DxColumn data-field="kelompok" caption="Kelompok"
                        :header-filter="{dataSource: commonStore.kelompokHeaderFilters}" />
                  <DxColumn data-field="jumlah_tunggakan" caption="Jumlah Tunggakan" :allowHeaderFiltering="false" />
                  <DxColumn data-field="nama_bacameter" caption="Nama Bacameter"  :visible="false"/>
                  <DxColumn data-field="tanggal_bacameter" caption="Tanggal Bacameter" 
                  :allowHeaderFiltering="false" :visible="false" dataType="dateTime"
                  />
                    <DxColumn data-field="tanggal_tugas" caption="Tanggal Tugas" 
                    :allowHeaderFiltering="false" dataType="date" :format="formaterStore.dateYyyyMmDd"/>
                  <DxColumn data-field="awal_rekening" caption="Awal Rekening" 
                  :allowHeaderFiltering="false" :visible="false"/>
                  <DxColumn data-field="akhir_rekening" caption="Akhir Rekening" 
                  :allowHeaderFiltering="false" :visible="false"/>
                
                  <DxColumn data-field="id_petugas_segel" caption="ID Petugas Segel" :visible="false" />
                  <DxColumn data-field="petugas_segel" :header-filter="{dataSource: dashboardStore.petugasSegelHeaderFilters}" caption="Petugas Segel" />
                  <DxColumn data-field="jml_bayar" caption="Jumlah Bayar" 
                     :allowHeaderFiltering="false" :format="formaterStore.priceFormat" />
                  <DxColumn data-field="created_at" caption="Created At" 
                  :allowHeaderFiltering="false" :visible="false"/>
                  <DxColumn data-field="updated_at" caption="Updated At" 
                  :allowHeaderFiltering="false" :visible="false"/>

<!--                   <DxColumn
                      caption="EDIT"
                      type="buttons"
                      :fixed="true"
                      fixedPosition="right"
                  >
                    <DxButtonDatagrid
                        name="edit"
                    />
                  </DxColumn> -->
                </DxDataGrid>  
                </div>
            </div>
          </div>
        </div>
      </DxTabPanelItem>
      <DxTabPanelItem title="Grafik" icon="textdocument">
        <div class="row">
          <!-- Barchart Tunggakan By JmlTunggakan-->
          <div class="col-lg-12">
            <div class="dx-card px-3 py-4 wide-card">
              <DxTagBox
                  :ref="dashboardStore.tagBoxKelompokRef"
                  :data-source="commonStore.kelompokHeaderFilters"
                  :show-selection-controls="true"
                  apply-value-mode="useButtons"
                  display-expr="text"
                  value-expr="value"
                  :placeholder="'Pilih Kelompok'"
                  v-model="dashboardStore.selectedKelompokScatter"
                  @selection-changed="dashboardStore.selectionBarChartKelompokChanged"
              />
              <div style="height: calc(100vh - 300px); min-height: 640px">
                <DxChart
                    :data-source="dashboardStore.dataSourceBarChartJmlTunggakanPerKelompok"
                    title="Jumlah Tagihan Per Cabang"
                    style="height: 100%;"
                >
                  <DxCommonSeriesSettings
                      argument-field="kelompok"
                      type="bar"
                      hover-mode="allArgumentPoints"
                      selection-mode="allArgumentPoints"
                  >
                    <DxLabel :visible="true">
                      <DxFormat
                          :precision="0"
                          type="fixedPoint"
                      />
                    </DxLabel>
                  </DxCommonSeriesSettings>
                  <DxValueAxis
                      title="Jumlah Sambungan">
                  </DxValueAxis>
                  <DxArgumentAxis
                      title="Kelompok"
                      :tick-interval="1">
                    <DxGrid :visible="true"/>
                    <DxLabel
                        :rotation-angle="20"
                        overlapping-behavior="rotate"
                        text="Jumlah Rekening"
                    />
                  </DxArgumentAxis>
                  <DxSeries
                      value-field="3-4"
                      name="3-4 Rekening"
                  />
                  <DxSeries
                      value-field="5-6"
                      name="5-6 Rekening"
                  />
                  <DxSeries
                      value-field="7-8"
                      name="7-8 Rekening"
                  />
                  <DxSeries
                      value-field="9-10"
                      name="9-10 Rekening"
                  />
                  <DxSeries
                      value-field=">10"
                      name=">10 Rekening"
                  />
                  <DxLegend
                      vertical-alignment="bottom"
                      horizontal-alignment="center"
                  />
                  <DxExport :enabled="true"/>
                </DxChart>
              </div>
            </div>
          </div>
        </div>
      </DxTabPanelItem>
      <DxTabPanelItem v-if="false" title="Sebaran Data" icon="share">
        <div class="row">
          <!-- Scatter Tunggakan-->
          <div class="col-lg-12">
            <div class="dx-card px-3 py-4 mt-3 wide-card">
              <DxTagBox
                  :ref="dashboardStore.tagBoxKelompokRef"
                  :data-source="dashboardStore.kelompokHeaderFilters"
                  :show-selection-controls="true"
                  apply-value-mode="useButtons"
                  display-expr="text"
                  value-expr="value"
                  :placeholder="'Pilih Kelompok'"
                  v-model="dashboardStore.selectedKelompokScatter"
                  @selection-changed="dashboardStore.selectionKelompokChanged"
              />
              <div style="height: calc(100vh - 200px);">
                <DxChart
                    :data-source="dashboardStore.datasourceScatterTunggakan"
                    title="Sebaran Data Tunggakan diatas 3 Rekening"
                    style="height: 100%"
                >
                  <DxCommonSeriesSettings type="scatter"/>

                  <DxSeries
                      argument-field="jml_tunggakan"
                      value-field="jml_bayar">
                    <DxPoint :size="6"/>
                  </DxSeries>
                  <DxValueAxis
                      title="Nominal">
                    <DxLabel :format="formaterStore.priceFormat"/>
                  </DxValueAxis>
                  <DxArgumentAxis
                      title="Jml Rekening"
                      :tick-interval="1">
                    <DxGrid :visible="true"/>
                    <DxLabel
                        :rotation-angle="20"
                        overlapping-behavior="rotate"
                        text="Jumlah Rekening"
                    />
                  </DxArgumentAxis>
                  <DxLegend :visible="false"/>
                  <DxCommonPaneSettings>
                    <DxBorder :visible="true"/>
                  </DxCommonPaneSettings>
                  <DxTooltip
                      :enabled="true"
                      :shared="true"
                      :customize-tooltip="dashboardStore.tooltipScatter"
                  />
                </DxChart>
              </div>
            </div>
          </div>
        </div>
      </DxTabPanelItem>
    </DxTabPanel>
    <DxLoadPanel :visible="dashboardStore.isDashboardLoading"/>
  </div>
</template>

<script setup>

import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxPaging,
  DxScrolling,
  DxFilterRow, DxPager, DxHeaderFilter, DxExport,
  DxItem,
  DxToolbar,
  DxColumnChooser,
  DxEditing,
  DxForm,
  DxPopup,
  DxButton as DxButtonDatagrid,
} from "devextreme-vue/data-grid";
import DxTabPanel, {DxItem as DxTabPanelItem} from "devextreme-vue/tab-panel";
import {
  DxChart,
  DxSeries,
  DxValueAxis,
  DxLabel,
  DxLegend,
  DxGrid,
  DxArgumentAxis,
  DxTooltip,
  DxCommonPaneSettings,
  DxBorder,
  DxPoint, DxCommonSeriesSettings, DxFormat,
} from 'devextreme-vue/chart';
import DxTagBox from 'devextreme-vue/tag-box';
import DxLoadPanel from 'devextreme-vue/load-panel';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxSelectBox from 'devextreme-vue/select-box';

import {useFormaterStore} from "@/store/utility/formatter-store";
import {useDashboardStore} from "@/store/views/dashboard-store";
import {useCommonStore} from "@/store/utility/common-store";
import {useMdrdStore} from "@/store/models/mdrd-store";
import { onMounted } from "vue";

const mdrdStore = useMdrdStore();
const dashboardStore = useDashboardStore();
const formaterStore = useFormaterStore();
const commonStore = useCommonStore();

onMounted(() => {
  dashboardStore.initialize();
});

</script>

<style lang="scss">
</style>
